import { ref, reactive, onMounted } from "vue"
import { getStatusBarInfo, nativeGoBack, getClientCommonMessage } from '@/utils/nativeFn'

export const useBaseNative = () => {
  const actionBarHeight = ref(79)

  onMounted(() => {
    getStatusBarInfo({}, (res: { height: number }) => {
      actionBarHeight.value = 44 + res.height || 35
    })
  })

  const goBack = (fn: () => any) => {
    nativeGoBack({}, (res: any) => {
      fn && fn()
    })
  }

  const setToken = async () => {
    const res: any = await getClientMessageSync()
    console.log(res.token)
    if (res) {
      res.token && localStorage.setItem('tal_token', res.token)
      res.user_id && localStorage.setItem('TAL_UID_TMP', res.user_id)
      res.services_version = localStorage.setItem('service_version', res.service_version)
    }
  }

  const getClientMessageSync = async () => {
    return new Promise((resolve, reject) => {
      getClientCommonMessage({}, (res) => {
        resolve(res)
      })
    })

  }

  return {
    actionBarHeight,
    goBack,
    setToken
  }
}